var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isRelativeTime)?_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.date),expression:"date"}]}):_c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.relativeTime)+" ")])]}}])},[_c('span',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.date),expression:"date"}]})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }